import {
  Button,
  ButtonVariants,
  Typography,
} from '../../components/primitives';
import Alert from '../../components/ui/Alert';
import ContactSupport from '../../components/ui/ContactSupport';
import { testId } from '../../utils';
import { PageCard } from './PageCard';
import { Cornerstone } from '@rpi/api';
import { Trans, useTranslation } from '@rpi/i18n';
import React, { useCallback, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

export const ForgotEmailSentRoute: React.FC = () => {
  const { t } = useTranslation(undefined, { keyPrefix: 'route.auth' });
  const email = useEmail();
  const { isSuccess, isLoading, mutate } = Cornerstone.useForgotPassword();
  const onClickResend = useCallback(() => {
    if (!email) {
      // User will be redirected
      return;
    }
    mutate({
      data: {
        email,
      },
    });
  }, [mutate, email]);

  return (
    <PageCard className="flex flex-col gap-6 text-center">
      {isSuccess && (
        <Alert {...testId('success')} variant="success">
          {t('forgot_password_link_sent')}
        </Alert>
      )}
      <Typography variant="title-default">
        {t('forgot_password_email_title')}
      </Typography>
      <Typography variant="body">
        <Trans i18nKey={t('forgot_password_email_text')} values={{ email }} />
      </Typography>
      <Typography variant="body">
        <Trans i18nKey={t('forgot_password_email_valid')} />
      </Typography>
      <div className="flex flex-col gap-2">
        <Typography variant="body">
          <Trans i18nKey={t('forgot_password_email_cant_find')} />
        </Typography>
        <Button
          {...testId('submit')}
          type="submit"
          onClick={onClickResend}
          loading={isLoading}
          variant={ButtonVariants.Secondary}
        >
          {t('resend')}
        </Button>
      </div>
      <ContactSupport />
    </PageCard>
  );
};

function useEmail() {
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email') || null;
  const navigate = useNavigate();
  useEffect(() => {
    if (!email) {
      navigate('/auth/sign-in', { replace: true });
    }
  }, [email, navigate]);
  return email;
}
